class NoteCard extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() {
    return ['title', 'body', 'date', 'color', 'note-id', 'archived'];
  }

  attributeChangedCallback() {
    this.render();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    const color = this.getAttribute('color') || '#ffffff';
    const title = this.getAttribute('title') || 'Untitled';
    const body = this.getAttribute('body') || '';
    const date = this.getAttribute('date')
      ? new Date(this.getAttribute('date')).toLocaleDateString('id-ID', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
      : '';
    const id = this.getAttribute('note-id') || '';
    const archived = this.getAttribute('archived') === 'true';

    this.innerHTML = `
      <div class="note-card" style="background-color: ${color};">
        <div class="note-actions">
          <button class="btn-archive">${archived ? 'Unarchive' : 'Archive'}</button>
          <button class="btn-delete">Delete</button>
        </div>
        <h3 class="note-title">${title}</h3>
        <small class="note-date">${date}</small>
        <p class="note-body">${body}</p>
      </div>
    `;

    const delBtn = this.querySelector('.btn-delete');
    const archiveBtn = this.querySelector('.btn-archive');

    if (delBtn) {
      delBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.dispatchEvent(
          new CustomEvent('delete-note', {
            detail: { id },
            bubbles: true,
            composed: true,
          })
        );
      });
    }

    if (archiveBtn) {
      archiveBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        this.dispatchEvent(
          new CustomEvent('toggle-archive', {
            detail: { id, archived: !archived },
            bubbles: true,
            composed: true,
          })
        );
      });
    }
  }
}

customElements.define('note-card', NoteCard);
